/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react'

// Third Party
import styled from 'styled-components'
import parse from 'html-react-parser'
import { Collapse } from 'react-bootstrap'

const Taxonomy = styled.div`
  cursor: pointer;
  
  input {
    display: none;
  }
  
  input:hover ~ label::before {
    border: 2px solid #2b2652;
  }
  
  input:checked ~ label::before {
    border: 2px solid #2b2652;
    background: #2b2652;
  }
`

const Label = styled.label`
  cursor: pointer;
  user-select: none;

  &::before {
    width: 14px;
    height: 14px;
    content: "";
    border: 2px solid #d1d7dc;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns=…28 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 2px 3px;
    z-index: 2;
    cursor: pointer;
    margin-right: 10px;
    -webkit-transition: 50ms;
    transition: 50ms;
  }
`

const Item = styled.p`
  margin-bottom: 0;
  ::first-letter {
    text-transform: uppercase;
  }
`

const CollapseButton = styled.div`
  :focus {
    outline: none;
  }
`

const FilterCategory = ({
  taxonomy,
  title,
  tag,
  activeFilterType,
  onChange,
  className,
  beOpen
}) => {

  /**
   * to prevent duplicates
   */
  function handleChange(item) {
    if (activeFilterType.includes(item)) {
      onChange(activeFilterType.filter(i => i !== item))
    } else {
      onChange([...activeFilterType, item])
    }
  }

  if (taxonomy.length === 0) {
    return false
  }

  const sanctifiedTaxonomy = taxonomy.reduce((result, element) => {
    const normalize = x => typeof x === 'string' ? x.toLowerCase() : x;

    const normalizedElement = normalize(element);
    if (result.every(otherElement => normalize(otherElement) !== normalizedElement))
      result.push(element);

    return result;
  }, [])

  const [open, setOpen] = useState(beOpen)

  return (
    <div className={`filter-wrapper mb-4 px-0 ${className}`}>
      <CollapseButton role="button" tabIndex="0" onKeyDown={() => setOpen(!open)} onClick={() => setOpen(!open)} aria-controls={tag} aria-expanded={open} className="filter-label d-flex align-items-center justify-content-between color-text-main font-size-m with-dot font-weight-xl mb-2">
        {title}
        <h2 className="m-0">{open ? `-` : '+'}</h2>
      </CollapseButton>
      <Collapse in={open}>
        <div id={tag}>
          {sanctifiedTaxonomy.map((item, index) => {
            return (
              <div key={index}>
                {item !== "Onbekend" && (
                  <Taxonomy key={item} className="filter-field mb-1 d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="mr-3"
                      checked={activeFilterType.includes(item)}
                      value={activeFilterType.includes(item)}
                      id={`${tag}_${item}`}
                      onChange={() => handleChange(item)}
                    />
                    <Label
                      className="d-flex align-items-center font-size-m font-weight-m color-text-main mb-0"
                      htmlFor={`${tag}_${item}`}
                    >
                      <Item>
                        {parse(item.toLowerCase().replace(/_/g, ' '))}
                      </Item>
                    </Label>
                  </Taxonomy>
                )}
              </div>
            )
          })}
        </div>
      </Collapse>
    </div>
  )
}

export default FilterCategory
